export default {"src":"/_next/static/media/googleplay.b51f490e.svg","height":48,"width":146,"blurWidth":0,"blurHeight":0};